export default "__VITE_ASSET__DAnGnE3R__"